module.exports = __webpack_public_path__ + "img/cun.ad8912ca.png";